import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "routeLine" }
const _hoisted_2 = { class: "routeLine__info" }
const _hoisted_3 = {
  key: 0,
  class: "routeLine__info__item"
}
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "routeLine__line" }, [
  /*#__PURE__*/_createVNode("div", { class: "iconPlane" })
], -1)

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      (_ctx.flyGroup)
        ? (_openBlock(), _createBlock("div", _hoisted_3, [
            _createTextVNode(" Стыковки: " + _toDisplayString(_ctx.flyGroup.count), 1 /* TEXT */),
            _createVNode("span", null, _toDisplayString(_ctx.flyGroup.routes), 1)
          ]))
        : _createCommentVNode("", true)
    ]),
    _hoisted_4
  ]))
}